var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container pt-2" }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-5 pt-4 mt-5 vaillantCont"
              },
              [
                _c("h4", { staticClass: "black center widthFull mt-4" }, [
                  _vm._v("Non hai preventivi accettati")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-lg btnYellow mt-2",
                    attrs: { to: "/offerte" }
                  },
                  [_vm._v("Gestione Preventivi")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-3 pt-3 align-items-end"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 col-md-3 pb-0 pl-1 pr-1 pl-md-5 pr-md-5 d-none d-md-block"
                  },
                  [
                    _vm.counts.countCashClient
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: parseFloat(_vm.counts.countCashClient),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": _vm.step
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v(" € ")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.counts.countCashClient
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("small", [
                                  _vm._v("Totale Fatt. quota Clienti")
                                ])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-5 col-md-3 pb-0 pr-0 pl-0" },
                  [
                    _vm.counts.countCashInst
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: parseFloat(_vm.counts.countCashInst),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": _vm.step
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v(" € ")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.counts.countCashInst
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("small", [
                                  _vm._v("Totale Fatt. quota Cessione")
                                ])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 col-md-3 center pl-1 pr-1 pl-md-5 pr-md-5  d-none d-md-block"
                  },
                  [
                    _vm.counts.countCashClient
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value:
                                parseFloat(_vm.counts.countCashClient) +
                                parseFloat(_vm.counts.countCashInst),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": _vm.step
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v(" € ")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        parseFloat(_vm.counts.countCashClient) +
                                          parseFloat(_vm.counts.countCashInst)
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("small", [_vm._v("Totale Fatturato")])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 col-md-3" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.searchBy("text", _vm.filterVal)
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "text-center grey pb-0 mb-0" }, [
                        _vm._v("Ricerca Pratica")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group mb-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterVal,
                              expression: "filterVal"
                            }
                          ],
                          staticClass: "form-control seachMobButton",
                          attrs: {
                            type: "text",
                            placeholder: "Numero Pratica o Cognome..."
                          },
                          domProps: { value: _vm.filterVal },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.filterVal = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group-append " }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary btnYellow",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.searchBy("text", _vm.filterVal)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "white",
                                attrs: { icon: "search", size: "sm" }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger widthFull mt-2",
                      staticStyle: { width: "68%" },
                      on: {
                        click: function($event) {
                          return _vm.searchBy("status", "10")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "trash-alt", size: "sm" }
                      }),
                      _vm._v(" Eliminate "),
                      _c("b", { staticClass: "ml-3" }, [
                        _vm._v(
                          " " + _vm._s(_vm.counts.hasRemovedPractics) + " "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btnYellow mt-2",
                      staticStyle: { width: "28%" },
                      on: {
                        click: function($event) {
                          return _vm.searchBy("", "")
                        }
                      }
                    },
                    [_vm._v("\n           Reset\n        ")]
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              { staticClass: "row justify-content-center align-items-end" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 col-md-2 text-left text-center text-md-left "
                  },
                  [
                    !_vm.lotOfData
                      ? _c(
                          "div",
                          { staticClass: "buttonTextCont widthfull " },
                          [
                            _c(
                              "h1",
                              {
                                staticClass: "widthFull mt-0 center pb-0 mb-0"
                              },
                              [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.counts.countPractices))
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-info btn-green btn-sm  widthFull",
                        on: {
                          click: function($event) {
                            return _vm.searchBy("", "")
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "white",
                          attrs: { icon: "clipboard-list", size: "sm" }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "d-none d-md-inline white" },
                          [_vm._v(" Totale Pratiche")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-4 col-md-2 text-center text-md-left" },
                  [
                    !_vm.lotOfData
                      ? _c(
                          "div",
                          {
                            staticClass: "buttonTextCont widthfull lightRight"
                          },
                          [
                            _c(
                              "h1",
                              {
                                staticClass: "widthFull mt-0 center pb-0 mb-0"
                              },
                              [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.counts.countErrorPractice))
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-danger btn-sm  widthFull",
                        on: {
                          click: function($event) {
                            return _vm.searchBy("errors", "")
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "exclamation-triangle", size: "sm" }
                        }),
                        _c("span", { staticClass: "d-none d-md-inline" }, [
                          _vm._v(" Con anomalie")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 col-4 col-md-2 text-center text-md-left  "
                  },
                  [
                    !_vm.lotOfData
                      ? _c(
                          "div",
                          {
                            staticClass: "buttonTextCont widthfull lightRight"
                          },
                          [
                            _c(
                              "h1",
                              {
                                staticClass: "widthFull mt-0 center pb-0 mb-0"
                              },
                              [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.counts.countStep1Practice))
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-danger btn-sm  widthFull",
                        on: {
                          click: function($event) {
                            return _vm.searchBy("status", "1")
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "white",
                          attrs: { icon: "balance-scale", size: "sm" }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "d-none d-md-inline white" },
                          [_vm._v(" Da completare")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left  " }, [
                  !_vm.lotOfData
                    ? _c("div", { staticClass: "buttonTextCont widthfull " }, [
                        _c(
                          "h1",
                          { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                          [
                            _c("b", [
                              _vm._v(_vm._s(_vm.counts.countStep2Practice))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-primary btn-sm btnYellow uppercase widthFull",
                      on: {
                        click: function($event) {
                          return _vm.searchBy("status", "2")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "balance-scale", size: "sm" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-md-inline white" }, [
                        _vm._v("In verifica")
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left" }, [
                  !_vm.lotOfData
                    ? _c("div", { staticClass: "buttonTextCont widthfull " }, [
                        _c(
                          "h1",
                          { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                          [
                            _c("b", [
                              _vm._v(_vm._s(_vm.counts.countStep3Practice))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-sm btnYellow widthFull",
                      on: {
                        click: function($event) {
                          return _vm.searchBy("status", "3")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "balance-scale", size: "sm" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-md-inline white" }, [
                        _vm._v(" In elaborazione ")
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left  " }, [
                  !_vm.lotOfData
                    ? _c("div", { staticClass: "buttonTextCont widthfull " }, [
                        _c(
                          "h1",
                          { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                          [
                            _c("b", [
                              _vm._v(_vm._s(_vm.counts.countStep4Practice))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-sm btn-green widthFull",
                      on: {
                        click: function($event) {
                          return _vm.searchBy("status", "4")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "balance-scale", size: "sm" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-md-inline white" }, [
                        _vm._v(" Elaborate ")
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator"
                  },
                  [
                    _vm.loaded
                      ? _c("pagination", {
                          attrs: {
                            options: {
                              theme: "bootstrap4",
                              texts: {
                                count:
                                  "Visualizzazione da {from} a {to} di {count} Pratiche|{count} Pratiche|Una Pratica"
                              }
                            },
                            records: _vm.practicesFiltredCount,
                            "per-page": _vm.displayPerPage
                          },
                          on: { paginate: _vm.callback },
                          model: {
                            value: _vm.page,
                            callback: function($$v) {
                              _vm.page = $$v
                            },
                            expression: "page"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5 " }, [
          !_vm.showFilterText
            ? _c(
                "div",
                { staticClass: "col-md-12 col-lg-12" },
                [
                  _c(
                    "badger-accordion",
                    {
                      key: "sdfg345",
                      staticClass: "pb-5 mt-4",
                      attrs: {
                        icons: {
                          opened: "<span></span>",
                          closed: "<span></span>"
                        }
                      }
                    },
                    _vm._l(_vm.practicesFiltred, function(item, key) {
                      return item.status != 10
                        ? _c(
                            "badger-accordion-item",
                            { key: item.code + "_" + _vm.countloop },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center "
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-9 text-center text-md-left"
                                        },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v(
                                              " Cessionario Finale:\n                    "
                                            ),
                                            item.flow == "poste"
                                              ? _c("b", [
                                                  _vm._v(" Poste Italiane ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "cdp"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Cassa Depositi e Prestiti "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "general"
                                              ? _c("b", [
                                                  _vm._v(" Flusso Base ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "agileenergy"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Flusso Agile Energy "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "mbfacta"
                                              ? _c("b", [
                                                  _vm._v(" Flusso MBFACTA ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "mbfacta_recovery"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Flusso Personalizzato "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "h5",
                                            {
                                              staticClass: "black csLineHeight2"
                                            },
                                            [
                                              _vm._v(
                                                "\n                     Pratica N. "
                                              ),
                                              _c(
                                                "b",
                                                { staticClass: "underline" },
                                                [_vm._v(_vm._s(item.code))]
                                              ),
                                              _vm._v(
                                                "\n                     del " +
                                                  _vm._s(
                                                    _vm
                                                      .moment(item.created_at)
                                                      .format(
                                                        "DD-MM-YYYY HH:mm"
                                                      )
                                                  ) +
                                                  " ( " +
                                                  _vm._s(item.bonus) +
                                                  " ) "
                                              ),
                                              item.payment_id != "0"
                                                ? [
                                                    item.flow != "agileenergy"
                                                      ? _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "green uppercase ml-4"
                                                          },
                                                          [_vm._v(" Pagata ")]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                : [
                                                    item.flow != "agileenergy"
                                                      ? _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "red uppercase ml-4"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Non Pagata "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" Cliente: "),
                                              _c("b", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.client_lastname
                                                    ) +
                                                    " " +
                                                    _vm._s(item.client_name) +
                                                    "  "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                " Indirizzo dell'immobile: "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.building_address
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      item.building_civic
                                                    ) +
                                                    " " +
                                                    _vm._s(item.building_city) +
                                                    " (" +
                                                    _vm._s(
                                                      item.building_province
                                                    ) +
                                                    ") CAP " +
                                                    _vm._s(item.building_zip) +
                                                    "  "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              item.flow != "agileenergy"
                                                ? [
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-2" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            " Totale Fatturato quota Cliente: "
                                                          ),
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "€ " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      item.total_transfer_for_client
                                                                    )
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          " Totale Fatturato quota Cessione: "
                                                        ),
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass: "black"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    item.total_bonus_savings
                                                                  )
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass: "pt-4 mb-1"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          [
                                                            _vm._v(
                                                              "\n\n                          Altri Oneri per il Committente: "
                                                            ),
                                                            _c(
                                                              "b",
                                                              {
                                                                staticClass:
                                                                  "black"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "€ " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        item.tot_extra_for_user
                                                                      )
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            item.payment_id !=
                                                            "0"
                                                              ? [
                                                                  _c(
                                                                    "b",
                                                                    {
                                                                      staticClass:
                                                                        "green uppercase ml-4"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Pagato "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              : [
                                                                  _c(
                                                                    "b",
                                                                    {
                                                                      staticClass:
                                                                        "red uppercase ml-4"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Non Pagato "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-1" },
                                                      [
                                                        _c(
                                                          "span",
                                                          [
                                                            _vm._v(
                                                              "\n                          Installazione e posa in opera  "
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              " dei beni per il Committente: "
                                                            ),
                                                            _c(
                                                              "b",
                                                              {
                                                                staticClass:
                                                                  "black ml-3"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "€ " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        item.tot_bonifico_for_user
                                                                      )
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            item.payment_id2 !=
                                                              "0" &&
                                                            item.payment_id2 !=
                                                              "1"
                                                              ? [
                                                                  _c(
                                                                    "b",
                                                                    {
                                                                      staticClass:
                                                                        "green uppercase ml-4"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Pagato "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              : [
                                                                  _c(
                                                                    "b",
                                                                    {
                                                                      staticClass:
                                                                        "red uppercase ml-4"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Non Pagato "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-2" },
                                                      [
                                                        _c("span", [
                                                          _c("br"),
                                                          _vm._v(
                                                            "Totale Fattura da installatore professionista in subappalto verso AGILE ENERGY\n                        "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "per il materiale e l'installazione, come indicati nel Preventivo: "
                                                          ),
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                "green"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "€ " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      item.totale_imponibile
                                                                    )
                                                                  ) +
                                                                  "*"
                                                              )
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _c("small", [
                                                          _vm._v(
                                                            "* Da fatturare "
                                                          ),
                                                          _c("b", [
                                                            _vm._v("senza IVA ")
                                                          ]),
                                                          _vm._v(
                                                            " in quanto operazione soggetta al reverse charge art. 17, comma 6, lett. a-ter DPR 633/1972.\n\n                       "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          " Costo di gestione del Servizio del General Contractor AGILE ENERGY\n                     "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "a supporto della gestione di questa Pratica è pari a:\n                     "
                                                        ),
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass: "green"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    item.price_agile
                                                                  )
                                                                ) +
                                                                " + IVA (22%)"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "che sarà fatturato da AGILE ENERGY verso l'installatore professionista in subappalto\n                   "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          item.flow != "agileenergy"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary m-2 btnBlue btn-sm",
                                                    attrs: {
                                                      href: item.signed_order,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "eye",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza Preventivo Firmato\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "agileenergy"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary m-2 btnBlue btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.lettera_di_affidamento_signed,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "eye",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza Lettera di Affidamento\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary m-2 btnBlue btn-sm",
                                                    attrs: {
                                                      href: item.signed_order,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "eye",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza Contratto per la fornitura e l’installazione\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow != "agileenergy"
                                            ? [
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-green m-2 btn-sm ",
                                                    attrs: {
                                                      to: {
                                                        name: "loadDocuments",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "clipboard-check",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Gestione Documenti\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "agileenergy" &&
                                          item.payment_id != 0
                                            ? [
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-green m-2 btn-sm ",
                                                    attrs: {
                                                      to: {
                                                        name: "loadDocuments",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "clipboard-check",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Gestione Documenti\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow != "agileenergy"
                                            ? [
                                                item.status == 1 &&
                                                item.payment_id == "0"
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-danger m-2 btn-sm",
                                                        attrs: {
                                                          type: "button"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removePractice(
                                                              item.id,
                                                              item.code,
                                                              key
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "trash-alt",
                                                              size: "sm"
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(
                                                          " Elimina\n                  "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 1
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: require("../../assets/images/traficLight_red.png")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 2 ||
                                          item.status == 3 ||
                                          item.status == 4
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: require("../../assets/images/traficLight_yellow.png")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 5
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: require("../../assets/images/traficLight_green.png")
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-7 col-md-1 center pl-md-0 pr-md-0 pt-3 "
                                        },
                                        [
                                          item.enea_request == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                class: {
                                                  "bg-success": _vm.checkEneaComplate(
                                                    item.aditional_enea_data
                                                  )
                                                },
                                                attrs: {
                                                  src: require("../../assets/images/enea.png")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.to_get_cadastral_data == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                class: {
                                                  "bg-success":
                                                    item.dcast_export == "10"
                                                },
                                                attrs: {
                                                  src: require("../../assets/images/dcast.png")
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-2 center pt-3" },
                                        [
                                          item.status == 1 &&
                                          item.flow != "agileenergy"
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "inline-block center relative topCust2 d-none d-md-inline ",
                                                  staticStyle: {
                                                    position:
                                                      "initial!important"
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "qrcodeImg qrcodeImg2",
                                                    attrs: { src: item.qrcode }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass: "qrcodeText"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Carica documenti con"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status != 1 &&
                                          item.ade_protocol_number
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "inline-block center relative topCust2 d-md-inline pt-4 pt-md-0 pb-0 ",
                                                  staticStyle: {
                                                    position:
                                                      "initial!important"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "pt-0 pt-md-2 pb-md-2 bgGreen white Regular"
                                                    },
                                                    [
                                                      _c("small", [
                                                        _c("b", [
                                                          _vm._v(
                                                            "Protocollo AdE nr. " +
                                                              _vm._s(
                                                                item.ade_protocol_number
                                                              )
                                                          )
                                                        ])
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.status == 1 && item.hasErrors == "no"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-11 col-md-11 mt-3 center requiredCont"
                                            },
                                            [
                                              item.flow == "poste"
                                                ? _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name: "loadDocuments",
                                                          params: { item: item }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "black widthFull text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                " mr-4"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Per procedere:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              " Prepara e carica tutta la documentazione nella sezione GESTIONE DOCUMENTI "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : item.flow == "cdp" ||
                                                  item.flow == "general" ||
                                                  item.flow == "mbfacta" ||
                                                  item.flow ==
                                                    "mbfacta_recovery"
                                                ? _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name: "loadDocuments",
                                                          params: { item: item }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "black widthFull text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                " mr-4"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Per procedere:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              " Prepara e carica tutta la documentazione nella sezione GESTIONE DOCUMENTI "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : item.flow == "agileenergy" &&
                                                  item.payment_id == "0"
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "black widthFull text-left"
                                                    },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass: " mr-4"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "In attesa Pagamento:"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          ' Appena riceviamo pagamento dal cliente finale "degli Altri Oneri al committente" - abilitiamo set documentale '
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : item.flow == "agileenergy" &&
                                                  item.payment_id != "0"
                                                ? _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name: "loadDocuments",
                                                          params: { item: item }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "black widthFull text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                " mr-4"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Per procedere:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              " Prepara e carica tutta la documentazione nella sezione GESTIONE DOCUMENTI "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.enea_request == "1" &&
                                      _vm.checkEneaComplate(
                                        item.aditional_enea_data
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-11  requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "Regular text-center h0 widthFull "
                                                },
                                                [
                                                  _c("b", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "green underline mr-3"
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "green",
                                                            attrs: {
                                                              href:
                                                                item.enea_pdf,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Dichiarazione ENEA "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    item.enea_email
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "green underline mr-3"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    item.enea_email,
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Ricevuta ENEA E-mail  "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("small", [
                                                      _vm._v("Il codice CPID:")
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.enea_cpid) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.modelloAde || item.ricevutaAde
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-11  requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "Regular text-center h0 widthFull "
                                                },
                                                [
                                                  _c("b", [
                                                    item.modelloAde
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "green underline mr-3"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    item.modelloAde,
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Modello AdE "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.ricevutaAde
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "green underline mr-3"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    item.ricevutaAde,
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Ricevuta AdE  "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.duediligence
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "green underline mr-3"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    item.duediligence,
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Due Diligence  "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (item.aditional_enea_data == null ||
                                        item.aditional_enea_data == "") &&
                                      item.enea_request == "1" &&
                                      item.payment_id != "0"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-11  requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "Regular text-center h0 widthFull "
                                                },
                                                [
                                                  _c("b", [
                                                    _c(
                                                      "span",
                                                      { staticClass: "red" },
                                                      [_vm._v("Attenzione!")]
                                                    ),
                                                    _vm._v(
                                                      " Per redigere ed inviare la Pratica ENEA necessitiamo di ulteriori informazioni "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "router-link",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary m-2 btn-sm",
                                                      attrs: {
                                                        to: {
                                                          name:
                                                            "complateEneaData",
                                                          params: { item: item }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Inserisci\n                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.hasErrors == "yes"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-11 col-md-11 mt-3 center requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "black widthFull text-left"
                                                },
                                                [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "widthFull mr-4"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "red" },
                                                        [_vm._v(" Attenzione ")]
                                                      ),
                                                      _vm._v(
                                                        " abbiamo rilevato le seguenti anomalie:"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "red widthFull text-left pl-4"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(item.errors) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 center pt-4"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "card step-progress pt-3 "
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "step-slider" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item ",
                                                      class: {
                                                        active:
                                                          item.status == 1,
                                                        "active passed":
                                                          item.status != 1
                                                      },
                                                      attrs: {
                                                        "data-id": "step1"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$router.push(
                                                            {
                                                              name:
                                                                "loadDocuments",
                                                              params: {
                                                                item: item
                                                              }
                                                            }
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 1 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(
                                                              "Carica Documentazione"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item ",
                                                      class: {
                                                        notactive:
                                                          item.status == 1,
                                                        active:
                                                          item.status == 2,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2
                                                      },
                                                      attrs: {
                                                        "data-id": "step2"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 2 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(
                                                              "In verifica"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item notactive",
                                                      class: {
                                                        notactive:
                                                          item.status == 2,
                                                        active:
                                                          item.status == 3,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2 &&
                                                          item.status != 3
                                                      },
                                                      attrs: {
                                                        "data-id": "step3"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 3 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(
                                                              "In elaborazione"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item notactive",
                                                      class: {
                                                        notactive:
                                                          item.status == 3,
                                                        active:
                                                          item.status == 4,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2 &&
                                                          item.status != 3 &&
                                                          item.status != 4
                                                      },
                                                      attrs: {
                                                        "data-id": "step4"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 4 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(" Elaborata")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "step-content"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasRemovedPractics
                    ? _c(
                        "div",
                        [
                          _vm.hasRemovedPractics
                            ? _c(
                                "h5",
                                { staticClass: "text-left black Regular" },
                                [_vm._v("Pratiche Eliminate")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRemovedPractics
                            ? _c(
                                "p",
                                { staticClass: "text-left black Regular" },
                                [
                                  _vm._v(
                                    "Attenzione! I dati contenuti in questa schermata non includono le Pratiche eliminate. "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "badger-accordion",
                            { staticClass: "pb-5 mt-4 greyBg" },
                            _vm._l(_vm.practicesFiltred, function(item, key) {
                              return item.status == 10
                                ? _c(
                                    "badger-accordion-item",
                                    {
                                      key: item.code + "12",
                                      staticClass: "greyBg"
                                    },
                                    [
                                      _c(
                                        "template",
                                        {
                                          staticClass: "greyBg",
                                          slot: "header"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center "
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-9 text-center text-md-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    { staticClass: "black" },
                                                    [
                                                      _vm._v(
                                                        "\n                          Pratica N. "
                                                      ),
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "underline"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.code)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                          del " +
                                                          _vm._s(
                                                            _vm
                                                              .moment(
                                                                item.created_at
                                                              )
                                                              .format(
                                                                "DD-MM-YYYY HH:mm"
                                                              )
                                                          ) +
                                                          " ( " +
                                                          _vm._s(item.bonus) +
                                                          " )\n                          per "
                                                      ),
                                                      _c("b", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.client_name
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              item.client_lastname
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary m-2 btnBlue btn-sm",
                                                      attrs: {
                                                        href: item.signed_order,
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "eye",
                                                          size: "sm"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        " visualizza Preventivo Firmato\n                        "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "col-md-3 center pt-3"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "template",
                                        {
                                          staticClass: "greyBg",
                                          slot: "content"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-9 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    { staticClass: "black" },
                                                    [
                                                      _vm._v(
                                                        " Indirizzo dell'immobile\n                          "
                                                      ),
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.building_address
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              item.building_civic
                                                            ) +
                                                            " - " +
                                                            _vm._s(
                                                              item.building_zip
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              item.building_city
                                                            ) +
                                                            " (" +
                                                            _vm._s(
                                                              item.building_province
                                                            ) +
                                                            ") "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass: "black pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Dati dell'intervento"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n                        Tipo: "
                                                  ),
                                                  _c("b", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "uppercase Regular"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.intervention_type
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "black pb-0 text-left widthFull"
                                                    },
                                                    [
                                                      _vm._v(" Da Cliente: "),
                                                      _c("b", [
                                                        _vm._v(
                                                          " € " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                parseFloat(
                                                                  item.total_transfer_for_client
                                                                )
                                                              )
                                                            )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "black pb-0 text-left"
                                                    },
                                                    [
                                                      _vm._v(" Da Cessione: "),
                                                      _c("b", [
                                                        _vm._v(
                                                          " € " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                parseFloat(
                                                                  item.total_transfer_for_user
                                                                )
                                                              )
                                                            )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "black pb-0 text-left"
                                                    },
                                                    [
                                                      _vm._v(" Totale: "),
                                                      _c("b", [
                                                        _vm._v(
                                                          " € " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                parseFloat(
                                                                  item.total_transfer_for_client
                                                                ) +
                                                                  parseFloat(
                                                                    item.total_transfer_for_user
                                                                  )
                                                              )
                                                            )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass: "black pb-0"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Data:")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .moment(
                                                                  item.intervention_date
                                                                )
                                                                .format(
                                                                  "DD-MM-YYYY"
                                                                )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5"
                },
                [
                  _c("h5", { staticClass: "center" }, [
                    _vm._v(
                      "Nessun risultato  " +
                        _vm._s(
                          _vm.filterVal != 1 &&
                            _vm.filterVal != 2 &&
                            _vm.filterVal != 3 &&
                            _vm.filterVal != 4
                            ? " per " + _vm.filterVal
                            : ""
                        )
                    )
                  ])
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator"
            },
            [
              _vm.loaded
                ? _c("pagination", {
                    attrs: {
                      options: {
                        theme: "bootstrap4",
                        texts: {
                          count:
                            "Visualizzazione da {from} a {to} di {count} Pratiche|{count} Pratiche|Una Pratica"
                        }
                      },
                      records: _vm.practicesFiltredCount,
                      "per-page": _vm.displayPerPage
                    },
                    on: { paginate: _vm.callback },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h3", { staticClass: "Regular  h0 widthFull" }, [
          _c("b", [_vm._v("Gestione Pratiche ")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe741b42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe741b42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pratiche/index.vue
// module id = null
// module chunks = 